"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _outOfStockModule = _interopRequireDefault(require("./out-of-stock.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var OutOfStock = function OutOfStock(_ref) {
  var _ref$outOfStock = _ref.outOfStock,
    outOfStock = _ref$outOfStock === void 0 ? false : _ref$outOfStock,
    _ref$isFutureRelease = _ref.isFutureRelease,
    isFutureRelease = _ref$isFutureRelease === void 0 ? false : _ref$isFutureRelease,
    className = _ref.className;
  if (!outOfStock || isFutureRelease) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: (0, _classnames.default)(className, _outOfStockModule.default['out-of-stock']),
    "data-testid": "out-of-stock",
    children: "Out of stock"
  });
};
OutOfStock.propTypes = {
  outOfStock: _propTypes.default.bool,
  isFutureRelease: _propTypes.default.bool
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(OutOfStock);